module.exports = __webpack_public_path__ + "img/20190530160942819.f7e21e0a.png";